import { getPercentageValue } from "./commonHelper";
import { convert } from "./currencyConvertion";
import moment from "moment";

export const getPricingDetails = (ordersDetails, base, rates) => {

    let pricingType, categoryCurrency, subTotal, visitFee, serviceFee = 0;
    let subCategoryTotal = 0, total = 0, userServiceFeeValue;
    if (ordersDetails?.length > 0) {
        pricingType = ordersDetails[0]?.categoryData?.pricingType;
        categoryCurrency = ordersDetails[0]?.categoryData?.currency;
        userServiceFeeValue = ordersDetails[0]?.categoryData?.userServiceFeeValue;
        ordersDetails?.map((item) => {
            pricingType == 'hourly' ?
                (subCategoryTotal += item?.pricingDetails?.convertBasePrice * item?.pricingDetails?.multiplierValue) :
                subCategoryTotal += (item?.quantity * item?.pricingDetails?.convertBasePrice)
        })
    }
    subTotal = subCategoryTotal;

    visitFee = convert(base, rates, ordersDetails[0]?.categoryData?.travellingPrice, categoryCurrency, base);
    serviceFee = getPercentageValue((subTotal + visitFee), userServiceFeeValue);
    total = subTotal + visitFee + serviceFee;

    return {
        serviceFee,
        subTotal,
        visitFee,
        total
    }

}

export const scheduleDateSplitUp = (scheduleDate) => {
    scheduleDate = scheduleDate ? moment(parseInt(scheduleDate)) : moment((new Date()).getTime() + 1200000)
    return {
        scheduleDate,
        scheduleHour: scheduleDate.format('h'),
        scheduleMinute: scheduleDate.format('mm'),
        scheduleMeridiem: scheduleDate.locale('en').format('A')
    }
}